import Card from "./Card";
import PersonIcon from "../PersonIcon";
import PropTypes from "prop-types";
import React from 'react';
import {connect} from "react-redux";
import {createDeleteEntityHandler} from "../utils/createDeleteEntityHandler";
import {sharedPortalStudents} from "../../../ducks";
import { renderApplyGrade, renderApplyYear, renderStudentName } from '../utils/studentDisplay';

const StudentCard = ({student, deleteStudent}) => {
  return (
    <Card
      icon={() => (<PersonIcon personName={renderStudentName(student)} />)}
      editLink={`/students/student/${student.id}`}
      onDelete={() => deleteStudent(student)}
    >
      <p>{`Applying for ${renderApplyGrade(student)} in ${renderApplyYear(student)}`}</p>
      <div className="sp-profile-card-heading">Current School</div>
      <p>{student.current_school}</p>
    </Card>
  );
};

StudentCard.propTypes = {
  student: PropTypes.shape({
    id: PropTypes.string,
    apply_grade: PropTypes.string,
    apply_year: PropTypes.number,
    current_school: PropTypes.string,
  }).isRequired
};

const mapDispatchToProps = (dispatch) => ({
  deleteStudent: createDeleteEntityHandler({
    dispatch,
    duck: sharedPortalStudents,
    confirmMessage: (student) => `Are you sure you want to delete student ${student.first_name} ${student.last_name}?
      Once deleted, you won't be able to submit new applications for this student, but any existing applications
      will remain unaffected.`,
    successMessage: () => "Student deleted."
  })
});

export default connect(undefined, mapDispatchToProps)(StudentCard);
